type SetCookie<TValue extends string> = (
  value: TValue,
  options: CookieOptions,
) => void;

export type CookieOptions = {
  expires: Date;
  domain: string;
  path: string;
  sameSite?: 'strict' | 'lax' | 'none';
  secure?: boolean;
};

export function useCookie<TValue extends string>(
  key: string,
  initialValue: TValue,
): [TValue, SetCookie<TValue>] {
  const getCookieValue = () => {
    if (typeof window !== 'undefined') {
      const value = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${key}=`))
        ?.split('=')[1];
      if (value !== undefined) {
        return value as TValue;
      }
    }
    return initialValue;
  };
  const cookie = getCookieValue();

  const setCookie =
    (key: string) => (value: TValue, options: CookieOptions) => {
      const expireDate = options.expires;
      let cookieString = `${key}=${value}; domain=${
        options.domain
      }; expires=${expireDate.toUTCString()}; path=${options.path}`;
      if (options.sameSite) {
        cookieString += `; samesite=${options.sameSite}`;
      }
      if (options.secure) {
        cookieString += '; secure';
      }
      document.cookie = cookieString;
    };

  return [cookie, setCookie(key)];
}
